<ag-brokersearch 
    optinapplicationcode="SILOPT" 
    optinapplicationcodenobroker="SILOPT" 
    optincode="SILGEN" 
    optincodenobroker="SILGEN" 
    mode="select-broker" #brokerSearchTool>	
</ag-brokersearch>